<ng-template #customizationModal let-modal>
  @if(productDetails){
    <div class="offcanvas-header border-bottom">
      <h4 class="modal-title mt-0">{{ productDetails.name | translate }}</h4>
      <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="offcanvas-body">
      @if(productDetails.variants && productDetails.variants.length > 0){
        <div class="border-bottom mt-3">
          <h4>{{ "heading-title.select-unit" | translate }}</h4>
          @for(variant of productDetails.variants; track $index) {
            <div class="form-check fs-5">
              <input class="form-check-input" type="radio" name="variant" [id]="variant._id" [value]="variant._id" [(ngModel)]="selectedVariantId" (change)="selectVariant(variant)"/>
              <label class="w-100 fw-normal" [for]="variant._id">
                <div class="d-flex justify-content-between align-items-center">
                  @if(productDetails.variantType === helper.VariantType.UNIT){
                    <span>{{ variant.unit.unitValue }} {{ helper.UnitTypeString[variant.unit.unitType] | translate }}</span>
                  } @else if (productDetails.variantType === helper.VariantType.SIZE && variant.unit.unitDescription){
                    <span>{{ variant.unit && variant.unit.unitQty === 1 ? variant.unit.unitDescription : variant.unit.unitQty + " x " + variant.unit.unitDescription }}</span>
                  }
                  <div class="d-flex gap-1">
                    <div class="d-flex ms-1 align-items-center">
                      <span class="current-price">
                        {{ variant.discountedPrice === 0 ? (0).toFixed(helper.adminSettings?.decimalPointValue) : variant.discountedPrice.toFixed(helper.adminSettings?.decimalPointValue) }}
                      </span>
                      <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                        {{ helper.currencySign }}
                      </span>
                    </div>
                    @if(variant.discountedPrice !== variant.price){
                      <div class="d-flex ms-1 align-items-center original-price">
                        <span>{{ variant.price.toFixed(helper.adminSettings?.decimalPointValue) }}</span>
                        <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                          {{ helper.currencySign }}
                        </span>
                      </div>
                    }
                  </div>
                </div>
              </label>
            </div>
          }
        </div>
      }
      @for(modifier of selectedVariantModifiers; track modifier.id; let modifierIndex = $index){
        <div class="py-3 border-bottom" [attr.id]="'modifier-' + modifier.id">
          <div class="d-flex align-items-center gap-2">
            <h4>{{ modifier.name }}</h4>
            <span class="fs-6 mb-2"
              [ngClass]="validationErrors[modifier.id] ? 'text-danger fw-semibold' : 'text-muted'"> 
              @if(modifier.minRange === 1 && modifier.maxRange > 1){
                ({{ "label-title.select-minimum" | translate }} {{ modifier.minRange }} {{ "label-title.and-up-to" | translate }} {{ modifier.maxRange }})
              } @else if(modifier.minRange === 0 && modifier.maxRange >= 1) {
                ({{ "label-title.select-up-to" | translate }} {{ modifier.maxRange }})
              } @else if(modifier.minRange === 1 && modifier.maxRange === 1) {
                ({{ "label-title.select-one" | translate }})
              }
            </span>
          </div>
          <div class="d-flex flex-column gap-2">
            @for(option of modifier.options; track option.id ; let optionIndex = $index){
              <div class="d-flex justify-content-between align-items-center">
                <div class="form-check fs-5 d-flex gap-2">
                  @if(modifier.maxRange === 1 && modifier.minRange === 1) {
                    <!-- Radio button for single selection -->
                    <input class="form-check-input" type="radio" 
                           name="modifier" 
                           id="option-{{ modifierIndex }}-{{ optionIndex }}" 
                           [value]="option.id" 
                           [checked]="option.isSelected" 
                           (change)="selectOption(option, modifier)"/>
                  } @else {
                    <!-- Checkbox for multiple selection -->
                    <input class="form-check-input" type="checkbox" 
                           id="option-{{ modifierIndex }}-{{ optionIndex }}" 
                           [checked]="option.isSelected" 
                           (change)="selectOption(option, modifier)"/>
                  }
                  <label class="form-check-label fw-normal d-flex flex-column" for="option-{{ modifierIndex }}-{{ optionIndex }}">
                    {{ option.name }} 
                    @if(option.price){
                      <div class="d-flex align-items-center text-muted fs-6">
                        <span>{{ option.price }}</span>
                        <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                          {{ helper.currencySign }}
                        </span>
                      </div>
                    }
                  </label>
                </div>                
                @if(modifier.isAllowAddQuantity && option.isSelected){
                  <div class="d-flex align-items-center">
                    <button class="btn btn-sm btn-danger" [ngStyle]="gridChildViewConfig && gridChildViewConfig.button ? getButtonStyle(gridChildViewConfig.button) : null" [disabled]="option.quantity === 1" (click)="decreaseQuantity(option)"><i class="ri-subtract-line"></i></button>
                      <span class="px-2"> {{ option.quantity }} </span>
                    <button class="btn btn-sm btn-danger" [ngStyle]="gridChildViewConfig && gridChildViewConfig.button ? getButtonStyle(gridChildViewConfig.button) : null" [disabled]="option.quantity === modifier.maxQtyAddInCart" (click)="increaseQuantity(option)"><i class="ri-add-line"></i></button>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="offcanvas-footer">
      <div class="d-flex gap-3">
        <div class="d-flex align-items-center gap-3 button">
          <button class="icon-button" (click)="decreaseProductQuantity()" [disabled]="totalProductQuantity === 1"><i class="ri-subtract-line"></i></button>
            <span class="text-white"> {{ totalProductQuantity }} </span>
          <button class="icon-button" (click)="increaseProductQuantity()" [disabled]="totalProductQuantity >= selectedVariantMaxQtyAddInCart"><i class="ri-add-line"></i></button>
        </div>
        @if(!isVariantOutOfStock){
          <button class="btn btn-dark w-100 d-flex justify-content-center gap-1 button" [disabled]="hasValidationErrors() || (getTotalPrice() === 0)" (click)="addProductToCart()">
            <span>{{ "button-title.add" | translate }}</span>
            <div class="d-flex ms-1 align-items-center" [@totalPriceChageAnimation]="getTotalPrice()">
              <span class="text-white"> {{ (getTotalPrice()).toFixed(helper.adminSettings?.decimalPointValue) }} </span>
              <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                {{ helper.currencySign }}
              </span>
            </div>
          </button>
        } @else {
          <button class="btn btn-dark w-100 d-flex justify-content-center disabled">
            {{ "label-title.out-of-stock" | translate }}
          </button>
        }
      </div>
    </div>
  }
</ng-template>
